import React from 'react';

import PropTypes from 'prop-types';
import { isEmpty, isArray, isUndefined } from 'lodash';

import { t, number } from '~/helpers';

import { Card } from '..';

// Serialize objects
function handleSerializeObject(params) {
  const {
    produtos,
    alertaressuprimentotanquefisico,
    falhacomunicacaotanquefisico,
    countalarmeslocalidade,
  } = params;

  const labels = [];
  const backgroundColor = [];
  const stock = [];
  const emptySpace = [];

  let emDescarga = false;
  let tipodescargaposto = null;
  const produtosEmDescarga = [];



  if (!isUndefined(produtos) && !isEmpty(produtos) && isArray(produtos)) {
    produtos.map((tank) => {
      const {
        nomeproduto,
        corproduto,
        volume1tanquefisico,
        volumeespacovaziotanquefisico,
        emdescarga,
        tipodescargaposto: tipoDescargaProduto,
      } = tank;

     if (Number(emdescarga) === 1) {
      emDescarga = true;
      if (nomeproduto) {
        produtosEmDescarga.push(nomeproduto.toUpperCase());
      }
    }

      if (tipodescargaposto === null && tipoDescargaProduto !== undefined) {
        tipodescargaposto = tipoDescargaProduto;
      }

      labels.push(nomeproduto.toUpperCase());
      backgroundColor.push(corproduto);
      stock.push(
        number(volume1tanquefisico, 0).replace('.', '').replace(',', '.')
      );
      emptySpace.push(
        number(volumeespacovaziotanquefisico, 0)
          .replace('.', '')
          .replace(',', '.')
      );

      return true;
    });
  }

  return {
    title: params.nomeposto,
    data: {
      labels,
      datasets: [
        {
          label: t('s.controleestoque.estoque'),
          backgroundColor,
          data: stock,
        },
        {
          label: t('s.controleestoque.espacovazio'),
          backgroundColor: '#E5E5E5',
          data: emptySpace,
        },
      ],
    },
    alarmes: countalarmeslocalidade > 0,
    status_comunicacao: falhacomunicacaotanquefisico > 0,
    alerta_ressuprimento: alertaressuprimentotanquefisico > 0,
    em_descarga: emDescarga,
    tipodescargaposto,
    produtos_em_descarga: produtosEmDescarga
  };
}

export default function List({ station, alarms, ...rest }) {
  return (
    <Card
      showAlarms={(params) => alarms(params)}
      showStation={() => station()}
      station={handleSerializeObject(rest)}
    />
  );
}

List.propTypes = {
  station: PropTypes.func.isRequired,
  alarms: PropTypes.func.isRequired,
};
